// extracted by mini-css-extract-plugin
module.exports = {"multiple":"MultipleTextArea_multiple__2Y5Cr","block":"MultipleTextArea_block__3rt6H","label":"MultipleTextArea_label__17ngr"};